import errorManager from '@/rollbar.js';

const initGetLabelsForVmd = (fromSelect) => {
  fromSelect = fromSelect !== false ? true : false;
  const vmdType = document.querySelector('#target_guest_vmd').value;
  const parameterConfigId = document.querySelector('#parameters_config_id').value;
  $.ajax({
    url: `/${window.locale}/parameters_configs/labels_for_vmd?vmd_type=${vmdType}&from_select=${fromSelect}&parameter_config_id=${parameterConfigId}`,
    type: 'GET',
    success: function (result) {
      resetFields();
      for (const [key, value] of Object.entries(result)) {
        if (result[key]) {
          if (fromSelect) {
            document.querySelector('#target_guest_vmd_label_ta').checked = true;
          }
          document.querySelector('#target_guest_vmd_' + key).style.visibility = 'visible';
          document.querySelector('#' + key).style.visibility = 'visible';
          document.querySelector('#' + key).innerText = result[key];
        }
      }
    },
    error: function (error) {
      console.log(`Error ${error}`);
    },
  });
};

const resetFields = () => {
  const labelkeys = ['label_ta', 'label_tb', 'label_tc', 'label_td', 'label_te', 'label_tf', 'label_tg', 'label_ti', 'label_tj'];
  const targetKeys = [
    'target_guest_vmd_label_ta',
    'target_guest_vmd_label_tb',
    'target_guest_vmd_label_tc',
    'target_guest_vmd_label_td',
    'target_guest_vmd_label_te',
    'target_guest_vmd_label_tf',
    'target_guest_vmd_label_tg',
    'target_guest_vmd_label_ti',
    'target_guest_vmd_label_tj',
  ];

  labelkeys.forEach((key) => {
    document.querySelector('#' + key).innerText = '';
  });

  targetKeys.forEach((key) => {
    document.querySelector('#' + key).style.visibility = 'hidden';
  });
};

const init = () => {
  try {
    $(document).on('change', '#target_guest_vmd', getLabelsForVmd);
  } catch (e) {
    console.error(e);
  }
};

const getLabelsForVmd = () => {
  try {
    initGetLabelsForVmd();
  } catch (e) {
    errorManager(e);
  }
};

window.LabelsSelectVmd = {
  init: init,
  getLabelsForVmd: getLabelsForVmd,
};
